<template>
  <b-popover :target="target" placement="bottom">
    <div class="toggle_stat"
        :class="{enabled_stat : stat_enabled('average')}"
        @click="$emit('toggle', 'average')">
      Average: {{average | round(2)}}
    </div>

    <div class="toggle_stat"
        :class="{enabled_stat : stat_enabled('median')}"
        @click="$emit('toggle', 'median')">
      Median: {{median | round(2)}}
    </div>

    <div class="toggle_stat">
      Std Dev: {{std_dev | round(2)}}
    </div>
  </b-popover>
</template>

<script>
const StatsCalculator = require('./stats_calculator').default

export default {
  name: 'StatsPopover',

  mixins : [StatsCalculator],

  props : {
    target : {
      type : String,
      required : true
    },

    stats : {
      type : Array,
      required : true
    },

    data : {
      //type : Object, // XXX: will throw err while transactioning
                       //      from period -> default report
      required : true
    }
  }
}
</script>

<style scoped>
.toggle_stat{
  cursor: pointer;
}

.enabled_stat{
  font-weight: bold;
}
</style>
